import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import {
    auth,
    googleProvider,
    db,
    doc,
    setDoc,
    getDoc
} from "./firebase";
import {
    createUserWithEmailAndPassword,
    signInWithPopup
} from "firebase/auth";
import { Timestamp } from "firebase/firestore";
import Turnstile from "react-turnstile";
import axios from "axios";

function Register() {
    const navigate = useNavigate();

    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [confirmPassword, setConfirmPassword] = useState("");
    const [error, setError] = useState("");
    const [token, setToken] = useState(null);
    const [loading, setLoading] = useState(false);
    const [turnstileVerified, setTurnstileVerified] = useState(false);

    const validateEmail = (email) => {
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        return emailRegex.test(email);
    };

    const containsScript = (input) => /<script.*?>.*?<\/script>/gi.test(input);


    const validateForm = () => {
        if (!email || !validateEmail(email)) {
            setError("Please enter a valid email.");
            return false;
        }


        if (containsScript(email) || containsScript(password)) {
            setError("Input contains forbidden content.");
            return false;
        }

        if (!email || !password) {
            setError("Please fill in all fields.");
            return;
        }
        if (password.length < 6) {
            setError("Password must be at least 6 characters.");
            return false;
        }
        if (password !== confirmPassword) {
            setError("Passwords do not match.");
            return false;
        }
        return true;
    };

    const handleEmailRegister = async (e) => {
        e.preventDefault();
        setError("");
        setLoading(true);

        if (!validateForm()) return;

        try {
            const userCredential = await createUserWithEmailAndPassword(
                auth,
                email,
                password
            );
            const user = userCredential.user;

            // Save user in Firestore
            await setDoc(doc(db, "users", user.uid), {
                uid: user.uid,
                email: user.email,
                type: "FREE",
                balance: 300,
                register_date: Timestamp.now(),
                role: "user", //Default role
            });
            navigate("/", { state: { registered: true } });

        } catch (err) {
            setLoading(false);
            console.error(err.message);
            //Custom error messages based on Firebase error codes
            if (err.code === "auth/email-already-in-use") {
                setError("This email is already registered. Please log in instead.");
            } else if (err.code === "auth/invalid-email") {
                setError("Please enter a valid email address.");
            } else if (err.code === "auth/weak-password") {
                setError("Password must be at least 6 characters long.");
            } else {
                setError("An error occurred. Please try again.");
            }
        }
    };

    const handleGoogleSignIn = async () => {
        setError("");
        try {
            const result = await signInWithPopup(auth, googleProvider);
            const user = result.user;

            const userRef = doc(db, "users", user.uid);
            const userSnap = await getDoc(userRef);

            if (!userSnap.exists()) {
                await setDoc(userRef, {
                    uid: user.uid,
                    name: user.displayName,
                    email: user.email,
                    type: "FREE",
                    balance: 300,
                    register_date: Timestamp.now(),
                });
            }

            navigate("/", { state: { registered: true } });
        } catch (err) {
            console.error(err.message);
            setError(err.message);
        }
    };

    return (
        <div className="login-container">
            <div className="login-card">
                <img src="/scrub_logo.png" alt="Scrub Mail logo" className="login-logo" />
                <h2 className="login-title">Sign Up for Free</h2>
                <h2 className="login-divider">
                    FREE SIGN UP • GET 300 FREE CREDITS • NO CREDIT CARD REQUIRED
                </h2>

                <div className="login-socials">
                    <button className="login-icon-btn" onClick={handleGoogleSignIn} ><img src="/graphic/web_light_sq_na@1x.png" alt="Google"/></button>
                    {/*<button className="login-icon-btn"><img src="/microsoft.svg" alt="Microsoft" /></button>*/}
                    {/*<button className="login-icon-btn"><img src="/github.svg" alt="GitHub" /></button>*/}
                    {/*<button className="login-icon-btn"><img src="/linkedin.svg" alt="LinkedIn" /></button>*/}
                </div>

                <div className="login-divider">OR SIGN UP USING EMAIL</div>

                <form onSubmit={handleEmailRegister} className="login-form">
                    <label>Email</label>
                    <input
                        type="email"
                        placeholder="enter your email"
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                        className="login-input"
                    />
                    <label>Password</label>
                    <input
                        type="password"
                        placeholder="enter your password"
                        value={password}
                        onChange={(e) => setPassword(e.target.value)}
                        className="login-input"
                    />
                    <label>Confirm password</label>
                    <input
                        type="password"
                        placeholder="confirm your password"
                        value={confirmPassword}
                        onChange={(e) => setConfirmPassword(e.target.value)}
                        className="login-input"
                    />

                    <p style={{ textAlign: "center", fontSize: "16px", color: "#888", marginBottom: "12px" }}>
                        By clicking, you agree to our <a href="/privacy_policy">Privacy Policy</a> and <a href="/terms_of_service">Terms of Service</a>.
                    </p>
                    <p></p>
                    <div className="turnstile-wrapper">
                        <Turnstile
                            sitekey={process.env.REACT_APP_TURNSTILE_SITE_KEY}
                            onVerify={async (token) => {
                                setToken(token);
                                try {
                                    const { data } = await axios.post("https://challenges.cloudflare.com/turnstile/v0/siteverify",
                                        new URLSearchParams({
                                            secret: process.env.REACT_APP_TURNSTILE_SECRET_KEY,
                                            response: token
                                        }),
                                        {
                                            headers: { "Content-Type": "application/x-www-form-urlencoded" }
                                        }
                                    );
                                    setTurnstileVerified(data.success);
                                } catch (err) {
                                    console.error("Turnstile error", err);
                                    setTurnstileVerified(false);
                                }
                            }}
                        />
                    </div>
                    <p></p>
                    {error && <div style={{ color: "red", marginBottom: "10px" }}>{error}</div>}

                    <button type="submit"  disabled={!turnstileVerified || loading} className="login-submit-btn">{loading ? "SIGNING IN..." : !turnstileVerified ? "PLEASE COMPLETE CAPTCHA" : "SIGN IN"}</button>
                </form>

                <div className="login-footer-links" style={{ marginTop: "20px" }}>
                    <a href="/login" >Already have an account?</a>
                </div>
            </div>
        </div>
    );
}

export default Register;